<template>
  <div>
    <div class="fix-wrapper">
      <breadcrumb
        :crumbs="[$t('menu.bargains'), $t('text.create')]"
      ></breadcrumb>
      <div class="container">
        <el-steps
          :active="2"
          finish-status="success"
          simple
          class="create-bargain-step"
        >
          <el-step title="添加订单"></el-step>
          <el-step title="添加产品(大货)"></el-step>
          <el-step title="添加收款"></el-step>
        </el-steps>
        <el-form
          ref="paymentForm"
          :model="payment"
          label-width="100px"
          size="small"
        >
          <div class="mg20">
            <fieldset>
              <legend class="center">
                <span class="float-left">{{ $t("bargain.orderAmount") }}</span>
                <span v-if="$route.query.payBalance == 'true'" class="red">
                  {{ $t("customer.balance")
                  }}{{ $route.query.customerBalance | currency }}
                </span>
              </legend>
            </fieldset>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item :label="$t('bargain.amount')"
                  >{{ currencySymbol }}{{ bargain.amount }}</el-form-item
                >
              </el-col>
              <el-col :span="8">
                <el-form-item :label="'款数'">{{
                  bargain.productNoQty
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('bargain.productQty')">{{
                  bargain.productQty
                }}</el-form-item>
              </el-col>
            </el-row>
            <template v-if="bargain.settleType == 'now'">
              <fieldset>
                <legend>
                  {{ $t("bargain.payment") }}
                </legend>
              </fieldset>
              <el-row :gutter="20">
                <el-col :span="16">
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item
                        :label="$t('payment.totalReceive')"
                        :prop="'total'"
                        :rules="[
                          {
                            required: true,
                            message: $t('rules.required', [
                              $t('payment.totalReceive'),
                            ]),
                            trigger: 'blur',
                          },
                        ]"
                      >
                        <el-input
                          v-model.trim="payment.total"
                          @change="blurJudgeBalance"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item
                        :label="$t('payment.payMethodReceive')"
                        :prop="'payMethodId'"
                        :rules="[
                          {
                            required: true,
                            message: $t('rules.required', [
                              $t('payment.payMethodReceive'),
                            ]),
                            trigger: 'blur',
                          },
                        ]"
                      >
                        <el-select
                          size="small"
                          v-model="payment.payMethodId"
                          filberable
                          @change="blurJudgeBalance"
                          :disabled="
                            $route.query.payBalance == 'true' ? true : false
                          "
                        >
                          <el-option
                            v-for="payMethod in payMethods"
                            :key="payMethod.id"
                            :label="payMethod.name"
                            :value="payMethod.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item
                        :label="$t('payment.explainReceive')"
                        :prop="'explain'"
                      >
                        <el-input
                          size="small"
                          v-model.trim="payment.explain"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item :label="$t('payment.ignoreAmount')">
                        <el-checkbox v-model="payment._paymentCompleted">
                          <!-- {{ currencySymbol }}
                          {{
                            Util.toFixed(
                              bargain.amount - Number(payment.total),
                              2
                            )
                          }} -->
                        </el-checkbox>
                      </el-form-item>
                    </el-col>
                    <el-col :span="7" v-if="payment._paymentCompleted">
                      <el-form-item label-width="10">
                        <el-input
                          size="small"
                          v-model.trim="payment._ignoreAmount"
                          :placeholder="
                            $t('payment.ignoreAmount') + $t('payment.total')
                          "
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('payment.voucherReceive')">
                    <dropzone v-model="payment.voucher" multiple />
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
          </div>
          <div class="form-footer">
            <el-button
              type="primary"
              size="medium"
              :loading="saveDoing"
              :disabled="saveDoing"
              @click="save(false)"
              plain
              >{{ $t("text.submit") }}</el-button
            >
            <el-button
              v-if="Permit.canActionsChargeEdition('orderConfirm')"
              type="success"
              size="medium"
              :loading="saveDoing"
              :disabled="saveDoing"
              @click="save(true)"
              plain
              >{{ $t("action.submitAndConfirm") }}</el-button
            >
          </div>
        </el-form>
        <div
          class="wrapper"
          v-if="
            bargain != null &&
            bargain.orders != null &&
            bargain.orders.length != 0 &&
            $route.query &&
            $route.query.type !== 'bulkOrder'
          "
        >
          <newed-orders
            :bargain="bargain"
            :currencySymbol="currencySymbol"
            :updateDataDF="true"
            @updateData="newedOrdersEdit"
          ></newed-orders>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ls from "store2";
import { page } from "@/utils/mixins.js";

import Util from "@/utils/index.js";
import Dropzone from "@/components/Dropzone";
import Bargain from "@/api/bargain.js";
import PayMethod from "@/api/payMethod.js";
import Customer from "@/api/customer.js";
import Payment from "@/api/payment.js";
import Order from "@/api/order.js";
import NewedOrders from "./newedOrders";

// const settleTypes = ["now", "later"];

export default {
  components: {
    Dropzone,
    NewedOrders,
  },
  mixins: [page],
  data() {
    return {
      Util: Util,
      bargain: { amount: null },
      currencySymbol: null,
      payMethods: [],
      customer: { balance: null },
      //
      saveDoing: false,
      payment: {
        total: null,
        payMethodId: null,
        payMethodName: null,
        explain: null,
        voucher: null,
        paidAt: null,
        settlementId: 0, // 先付款
        currency: null,
        bargainId: null,
        customerId: null,
        _paymentCompleted: false,
        _ignoreAmount: 0,
        type: "receivables", // return
      },
    };
  },
  created() {
    const self = this;
    Bargain.findByUuid({ uuid: self.$route.query.bargainUuid }).then(function (
      res
    ) {
      if (res.status == 200) {
        self.bargain = res.data.entity;
        // 币种
        const currentCurrencies = ls.session("CURRENCIES");
        const currencyObj = currentCurrencies.find(
          (c) => c.code === self.bargain.currency
        );
        self.currencySymbol = currencyObj.symbol;
        //
        self.payment.total = self.bargain.amount;
        self.payment._ignoreAmount = 0;
        if (self.bargain.settleType == "now") {
          axios
            .all([
              PayMethod.findByTypes({ types: PayMethod.saleTypes }),
              Customer.findById(self.bargain.customerId),
            ])
            .then(
              axios.spread(function (payMethods, customer) {
                if (payMethods.status === 200) {
                  self.payMethods = payMethods.data;
                } else {
                  self.sysError();
                }
                if (customer.status === 200) {
                  self.customer = customer.data.entity;
                  if (self.bargain.currency == "CNY" && self.customer) {
                    self.payMethods.push({
                      id: -1,
                      name: "账户余额(¥" + self.customer.balance + ")",
                    });
                  }
                  if (self.$route.query.payBalance == "true") {
                    self.payment.payMethodId = -1;
                  }
                  self.blurJudgeBalance();
                } else {
                  self.sysError();
                }
              })
            );
        }
      } else {
        self.sysError();
      }
    });
  },

  methods: {
    newedOrdersEdit() {
      const self = this;
      Bargain.findByUuid({ uuid: self.bargain.uuid }).then(function (res) {
        if (res.status === 200) {
          self.bargain = res.data.entity;
          //
          self.payment.total = self.bargain.amount;
          self.payment._ignoreAmount = 0;
        } else {
          self.sysError();
        }
      });
    },
    blurJudgeBalance() {
      const self = this;
      if (
        self.customer != null &&
        self.payment.payMethodId == -1 &&
        self.payment.total > self.customer.balance
      ) {
        self.payment.payMethodId = null;
        self.$message({
          message: self.$t("prompt.customerBalanceNotEnougth"),
          type: "warning",
        });
      }
      if (self.bargain.amount - self.payment.total > 0) {
        self.payment._ignoreAmount = self.bargain.amount - self.payment.total;
      }
    },
    save(confirm) {
      const self = this;
      // console.log("===========", confirm);
      if (self.bargain.settleType == "now") {
        // 现结
        self.$refs.paymentForm.validate((valid) => {
          if (valid) {
            let data = [];
            self.payment.payMethodName = self.payMethods.find(
              (p) => p.id == self.payment.payMethodId
            ).name;
            self.payment.paidAt = Util.formatDate(new Date()) + " 00:00:00";
            self.payment.currency = self.bargain.currency;
            self.payment.bargainId = self.bargain.id;
            self.payment.customerId = self.bargain.customerId;
            data.push(self.payment);
            if (self.payment._paymentCompleted) {
              data.push({
                // total: self.bargain.amount - Number(self.payment.total),
                total: self.payment._ignoreAmount,
                payMethodId: 0,
                payMethodName: "抹零",
                explain: null,
                voucher: null,
                paidAt: Util.formatDate(new Date()) + " 00:00:00",
                settlementId: 0,
                currency: self.bargain.currency,
                bargainId: self.bargain.id,
                customerId: self.bargain.customerId,
                type: "receivables",
              });
            }
            self.saveDoing = true;
            Payment.insertBatch(data).then(function (res) {
              if (res.status === 200) {
                self.orderConfirm(confirm);
              } else {
                self.sysError();
              }
              self.saveDoing = false;
            });
          } else {
            return false;
          }
        });
      } else {
        // 账单结算
        self.orderConfirm(confirm);
      }
    },
    orderConfirm(confirm) {
      const self = this;
      if (confirm && self.bargain.orders.length != 0) {
        Order.batchConfirm(self.bargain.orders.map((o) => o.id)).then(function (
          res
        ) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.submitComfirmSuccess"),
              type: "success",
            });
            if (self.Permit.currentTenant().config.bulkOrder) {
              self.$router.push("/normal/oms/bargainsBulk");
            } else {
              self.$router.push("/normal/oms/bargains");
            }
            self.$eventHub.$emit("orderBatchConfirm");
          } else {
            self.sysError();
          }
        });
      } else {
        self.$message({
          message: self.$t("prompt.submitSuccess"),
          type: "success",
        });
        if (self.$route.query && self.$route.query.type == "bulkOrder") {
          self.$router.push("/normal/oms/bargainsBulk");
        } else {
          self.$router.push("/normal/oms/bargains");
        }
      }
    },
  },
};
</script>

